<og-auth-shell active="sign-up"
  ><section class="og-auth-form">
    <h2>Create your <span>account</span></h2>
    <p class="auth-description">Set up your program in under a minute. Payment on next step.</p>
    <form
      #signUpNgForm="ngForm"
      (ngSubmit)="signUp()"
      [formGroup]="signUpForm"
      class="auth-form-grid"
    >
      <mat-form-field subscriptSizing="dynamic" class="auth-half">
        <input
          aria-label="First Name"
          placeholder="First Name"
          formControlName="first_name"
          id="first_name"
          matInput
        />
        <mat-error *ngIf="signUpForm.get('first_name').hasError('required')">
          First name is required
        </mat-error>
        <mat-error *ngFor="let error of errorMessages['first_name']"> {{ error }}</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-half">
        <input
          aria-label="Last Name"
          placeholder="Last Name"
          formControlName="last_name"
          id="last_name"
          matInput
        />
        <mat-error *ngIf="signUpForm.get('last_name').hasError('required')">
          Last name is required
        </mat-error>
        <mat-error *ngFor="let error of errorMessages['last_name']"> {{ error }}</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Club Name"
          placeholder="Program / Club name"
          formControlName="club_name"
          id="club_name"
          matInput
        />
        <mat-error *ngIf="signUpForm.get('club_name').hasError('required')">
          Club name is required
        </mat-error>
        <mat-error *ngFor="let error of errorMessages['club_name']"> {{ error }}</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Username"
          placeholder="Username"
          formControlName="username"
          id="username"
          autocomplete="username"
          matInput
        />
        <mat-error *ngIf="signUpForm.get('username').hasError('required')">
          Username is required
        </mat-error>

        <mat-error *ngFor="let error of errorMessages['username']">
          {{ error }}
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Email address"
          placeholder="Email address"
          formControlName="email"
          id="email"
          type="email"
          autocomplete="email"
          matInput
        />
        <mat-error *ngIf="signUpForm.get('email').hasError('required')">
          Email address is required
        </mat-error>
        <mat-error *ngIf="signUpForm.get('email').hasError('email')">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="signUpForm.get('email').hasError('serverError')">
          {{ errorMessages['email'].join('\n') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Phone Number"
          placeholder="Phone Number"
          matInput
          id="phone_number"
          type="tel"
          autocomplete="tel"
          formControlName="phone_number"
          mask="(000) 000-0000"
        />
        <mat-error *ngIf="signUpForm.get('phone_number').hasError('required')">
          Phone number is required
        </mat-error>
        <mat-error *ngIf="signUpForm.get('phone_number').hasError('phone_number')">
          Please enter a valid phone number
        </mat-error>
        <mat-error *ngIf="signUpForm.get('phone_number').hasError('serverError')">
          {{ errorMessages['phone_number'].join('\n') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-half">
        <input
          aria-label="Password"
          placeholder="Password"
          #passwordField
          formControlName="password1"
          id="password1"
          autocomplete="new-password"
          matInput
          type="password"
        />
        <button
          (click)="
            passwordField.type === 'password'
              ? (passwordField.type = 'text')
              : (passwordField.type = 'password')
          "
          aria-label="Toggle password visibility"
          mat-icon-button
          matSuffix
          type="button"
        >
          <mat-icon
            *ngIf="passwordField.type === 'password'"
            [svgIcon]="'heroicons_solid:eye'"
            class="icon-size-5"
          ></mat-icon>
          <mat-icon
            *ngIf="passwordField.type === 'text'"
            [svgIcon]="'heroicons_solid:eye-slash'"
            class="icon-size-5"
          ></mat-icon>
        </button>
        <mat-error> Password is required </mat-error>
        <mat-error *ngFor="let error of errorMessages['password1']">
          {{ error }}
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-half">
        <input
          aria-label="Confirm Password"
          placeholder="Confirm Password"
          #confimPasswordField
          formControlName="password2"
          id="password2"
          autocomplete="new-password"
          matInput
          type="password"
        />
        <button
          (click)="
            confimPasswordField.type === 'password'
              ? (confimPasswordField.type = 'text')
              : (confimPasswordField.type = 'password')
          "
          aria-label="Toggle password visibility"
          mat-icon-button
          matSuffix
          type="button"
        >
          <mat-icon
            *ngIf="confimPasswordField.type === 'password'"
            [svgIcon]="'heroicons_solid:eye'"
            class="icon-size-5"
          ></mat-icon>
          <mat-icon
            *ngIf="confimPasswordField.type === 'text'"
            [svgIcon]="'heroicons_solid:eye-slash'"
            class="icon-size-5"
          ></mat-icon>
        </button>
        <mat-error *ngIf="isControlHasError('password2', 'maxlength')">
          <strong>Password should be 100 max</strong>
        </mat-error>
        <mat-error
          *ngIf="signUpForm.get('password2').errors && signUpForm.get('password2').errors.noMatch"
        >
          <strong>Password and Confirm Password didn't match.</strong>
        </mat-error>
        <mat-error *ngFor="let error of errorMessages['password2']">
          {{ error }}
        </mat-error>
      </mat-form-field>

      <div class="auth-agreement">
        <mat-checkbox
          id="terms-consent"
          formControlName="agree"
          aria-label="I agree to the Terms and Conditions and Privacy Policy"
        ></mat-checkbox
        ><label for="terms-consent-input"
          >I agree to the
          <a href="https://www.optimumgrading.com/terms" target="_blank" rel="noopener noreferrer"
            >Terms &amp; Conditions</a
          >
          and
          <a href="https://www.optimumgrading.com/privacy" target="_blank" rel="noopener noreferrer"
            >Privacy Policy</a
          >.</label
        >
      </div>

      <button
        type="submit"
        [color]="'primary'"
        [disabled]="(loading$ | async) || signUpForm.invalid"
        class="auth-submit"
        mat-flat-button
      >
        <span *ngIf="!(loading$ | async)"> Sign up <span aria-hidden="true">→</span></span>
        <mat-progress-spinner
          *ngIf="loading$ | async"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </form>
    <p class="auth-footer">
      Already have an account? <a routerLink="/authentication/sign-in">Sign in</a>
    </p>
  </section></og-auth-shell
>
